export default class extends google.maps.OverlayView {
  constructor({ map, initialTitle, markerPosition, callback, autoClose }) {
    super()
    this.callback = callback
    this.markerPosition = markerPosition
    this.initialTitle = initialTitle
    this.setMap(map)
    if (autoClose) this.setAutoCloseTimeout()
  }

  setAutoCloseTimeout() {
    this.timer = setTimeout(_ =>
      this.setMap(null)
    , 10000)
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  position() {
    const overlayProjection = this.getProjection()
    const latLngPxl = overlayProjection.fromLatLngToDivPixel(this.markerPosition)
    latLngPxl.x = latLngPxl.x - 15
    latLngPxl.y = latLngPxl.y + 30
    return overlayProjection.fromDivPixelToLatLng(latLngPxl)
  }

  initRectangle(bounds) {
    this.rectangle = new google.maps.Rectangle({
      bounds: bounds,
      map: this.map,
      strokeColor: '#000',
      suppressUndo: true,
      strokeOpacity: 1,
      strokeWeight: 1,
      fillOpacity: 0,
      zIndex: 109
    })

    google.maps.event.addListener(this.rectangle, 'mousedown', e => {
      this.clearTimer()
      e.stop()
    })

    google.maps.event.addListener(this.rectangle, 'dblclick', e => {
      e.stop()
      this.edit()
    })
  }

  edit() {
    setTimeout(_ => {
      this.spanElement.contentEditable = true
      this.spanElement.focus()
      document.execCommand('selectAll', false, null)
    }, 1)
  }

  onAdd() {
    this.containerElement = document.createElement('div')
    this.containerElement.style.padding = '5px'
    this.containerElement.style.position = 'absolute'
    this.containerElement.style.cursor = 'move'
    this.containerElement.style.display = 'block'
    this.containerElement.style.backgroundColor = '#fff'
    this.containerElement.style.textAlign = 'center'
    this.containerElement.style.overflow = 'hidden'

    this.spanElement = document.createElement('span')
    this.spanElement.textContent = this.initialTitle
    this.spanElement.style.display = 'inline-block'
    this.spanElement.style.whiteSpace = 'nowrap;'
    this.spanElement.style.color = '#000'
    this.spanElement.style.verticalAlign = 'middle'
    this.spanElement.style.lineHeight = '1em'
    this.containerElement.appendChild(this.spanElement)

    google.maps.event.addDomListener(this.spanElement, 'keydown', e => {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.spanElement.blur()
      }
    })

    google.maps.event.addDomListener(this.spanElement, 'keyup', e => {
      this.clearTimer()
      this.title = this.spanElement.textContent
      this.draw()
    })

    google.maps.event.addDomListener(this.spanElement, 'blur', e => this.complete())

    const panes = this.getPanes()
    panes.overlayShadow.appendChild(this.containerElement)
    this.edit()
  }

  draw(params) {
    const overlayProjection = this.getProjection()
    const latLngPxl = overlayProjection.fromLatLngToDivPixel(this.position())
    this.containerElement.style.left = (latLngPxl.x - this.containerElement.offsetWidth / 2) + 'px'
    this.containerElement.style.top = (latLngPxl.y - this.containerElement.offsetHeight / 2) + 'px'

    const sw = overlayProjection.fromDivPixelToLatLng(new google.maps.Point(latLngPxl.x - this.containerElement.offsetWidth / 2, latLngPxl.y - this.containerElement.offsetHeight / 2))
    const ne = overlayProjection.fromDivPixelToLatLng(new google.maps.Point(latLngPxl.x + this.containerElement.offsetWidth / 2, latLngPxl.y + this.containerElement.offsetHeight / 2))
    const rectangleBounds = new google.maps.LatLngBounds(sw, ne)

    if (this.rectangle) {
      this.rectangle.setBounds(rectangleBounds)
    } else {
      this.initRectangle(rectangleBounds)
    }
  }

  onRemove() {
    this.clearTimer()
    this.containerElement.parentNode.removeChild(this.containerElement)
    this.rectangle.setMap(null)
  }

  titleChanged() {
    return typeof this.title !== 'undefined' &&
    this.title !== '' &&
    this.title !== this.initialTitle
  }

  complete() {
    this.titleChanged() && this.callback(this.title)
    this.setMap(null)
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/RenameCameraOverlay.js